/**
 * Schakelaars voor functionaliteit die tijdelijk uit staat.
 *
 * Elke plek in de app die zo'n functie gebruikt leest de vlag hier. Weer
 * aanzetten is dus één regel in dit bestand veranderen; er hoeft verder geen
 * code terug.
 */

/**
 * Het ingesproken vertaal-commandowoord: spreekt de zorgverlener de ingestelde
 * triggerzin uit (bijv. "Lees voor"), dan worden de ongelezen berichten
 * vertaald en voorgelezen aan de patiënt.
 *
 * Staat uit. Vertalen blijft gewoon mogelijk via de Vertaal-knop en via de
 * sneltoets (pijltje rechts / PageDown); alleen het spraakcommando luistert
 * niet meer mee.
 *
 * Weer aanzetten: deze constante op `true` zetten. De instelling "Vertaal
 * trigger" in de praktijk- en gebruikersinstellingen en de bijbehorende
 * onboardingstap verschijnen dan vanzelf weer.
 */
export const VOICE_TRANSLATE_COMMAND_ENABLED = false;
